// packages/ag-charts-locale/src/pt-BR.ts
var AG_CHARTS_LOCALE_PT_BR = {
  ariaAnnounceChart: "gr\xE1fico, ${seriesCount}[number] s\xE9ries",
  ariaAnnounceFlowProportionLink: "link ${index} de ${count}, de ${from} para ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "n\xF3 ${index} de ${count}, ${description}",
  ariaAnnounceGaugeChart: "gr\xE1fico de medidor, ${caption}",
  ariaAnnounceHierarchyChart: "gr\xE1fico de hierarquia, ${caption}",
  ariaAnnounceHierarchyDatum: "n\xEDvel ${level}[number], ${count}[number] filhos, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Pressione Espa\xE7o ou Enter para alternar a visibilidade",
  ariaLabelAddHorizontalLine: "Adicionar Linha Horizontal",
  ariaLabelAnnotationOptionsToolbar: "Op\xE7\xF5es de Anota\xE7\xE3o",
  ariaLabelAnnotationSettingsDialog: "Configura\xE7\xF5es de Anota\xE7\xE3o",
  ariaLabelColorPicker: "Seletor de cores",
  ariaLabelFinancialCharts: "Gr\xE1ficos financeiros",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Item da legenda ${index}[number] de ${count}[number]",
  ariaLabelLegendItemUnknown: "Item desconhecido da legenda",
  ariaLabelLegendPageNext: "Pr\xF3xima P\xE1gina da Legenda",
  ariaLabelLegendPagePrevious: "P\xE1gina Anterior da Legenda",
  ariaLabelLegendPagination: "Pagina\xE7\xE3o da Legenda",
  ariaLabelNavigator: "Navegador",
  ariaLabelNavigatorMaximum: "M\xE1ximo",
  ariaLabelNavigatorMinimum: "M\xEDnimo",
  ariaLabelNavigatorRange: "Intervalo",
  ariaLabelRangesToolbar: "Faixas",
  ariaLabelSettingsTabBar: "Configura\xE7\xF5es",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] a ${max}[percent0to2dp]",
  contextMenuDownload: "Baixar",
  contextMenuPanToCursor: "Mover para aqui",
  contextMenuToggleOtherSeries: "Alternar Outras S\xE9ries",
  contextMenuToggleSeriesVisibility: "Alternar Visibilidade",
  contextMenuZoomToCursor: "Dar zoom aqui",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Data e Pre\xE7o",
  dialogHeaderDateRange: "Intervalo de Datas",
  dialogHeaderFibonacciRange: "Retra\xE7\xE3o de Fib",
  dialogHeaderLine: "Linha",
  dialogHeaderPriceRange: "Faixa de Pre\xE7o",
  dialogHeaderText: "Texto",
  dialogInputAlign: "Alinhar",
  dialogInputColorPicker: "Cor",
  dialogInputColorPickerAltText: "Cor do Texto",
  dialogInputExtendAbove: "Estender acima",
  dialogInputExtendBelow: "Estender abaixo",
  dialogInputExtendChannelEnd: "Estender final do canal",
  dialogInputExtendChannelStart: "Estender in\xEDcio do canal",
  dialogInputExtendLeft: "Estender \xE0 esquerda",
  dialogInputExtendLineEnd: "Estender fim da linha",
  dialogInputExtendLineStart: "Estender in\xEDcio da linha",
  dialogInputExtendRight: "Estender \xE0 direita",
  dialogInputFibonacciBands: "Bandas",
  dialogInputFibonacciBandsAltText: "Bandas de Fibonacci",
  dialogInputFillColorPicker: "Preencher",
  dialogInputFillColorPickerAltText: "Cor de Preenchimento",
  dialogInputFontSize: "Tamanho",
  dialogInputFontSizeAltText: "Tamanho da Fonte",
  dialogInputLineStyle: "Tracejado",
  dialogInputPosition: "Posi\xE7\xE3o",
  dialogInputReverse: "Inverter",
  dialogInputShowFill: "Exibir Preenchimento",
  dialogInputStrokeWidth: "Peso",
  dialogInputStrokeWidthAltText: "Peso da Linha",
  iconAltTextAlignCenter: "Centralizar",
  iconAltTextAlignLeft: "Esquerda",
  iconAltTextAlignRight: "Direita",
  iconAltTextClose: "Fechar",
  iconAltTextLineStyleDashed: "Tra\xE7o longo",
  iconAltTextLineStyleDotted: "Tra\xE7o Curto",
  iconAltTextLineStyleSolid: "S\xF3lido",
  iconAltTextPositionBottom: "Inferior",
  iconAltTextPositionCenter: "Centro",
  iconAltTextPositionTop: "Topo",
  inputTextareaPlaceholder: "Adicionar Texto",
  measurerDateRangeBars: "${value}[number] barras",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: '"Vol ${value}"',
  overlayLoadingData: "Carregando dados...",
  overlayNoData: "Sem dados para exibir",
  overlayNoVisibleSeries: "Nenhuma s\xE9rie vis\xEDvel",
  overlayUnsupportedBrowser: "Vers\xE3o do navegador incompat\xEDvel. Por favor, atualize seu navegador.",
  seriesHistogramTooltipCount: "${yName} (contagem)",
  seriesHistogramTooltipFrequency: "Frequ\xEAncia",
  seriesHistogramTooltipMean: "${yName} (m\xE9dia)",
  seriesHistogramTooltipSum: "${yName} (soma)",
  toolbarAnnotationsArrow: "Seta",
  toolbarAnnotationsArrowDown: "Seta para Baixo",
  toolbarAnnotationsArrowUp: "Seta para cima",
  toolbarAnnotationsCallout: "Anota\xE7\xE3o",
  toolbarAnnotationsClearAll: "Limpar Tudo",
  toolbarAnnotationsComment: "Comentar",
  toolbarAnnotationsDatePriceRange: "Data e Pre\xE7o",
  toolbarAnnotationsDateRange: "Intervalo de Datas",
  toolbarAnnotationsDelete: "Excluir",
  toolbarAnnotationsDisjointChannel: "Canal Independente",
  toolbarAnnotationsDragHandle: "Arrastar Barra de Ferramentas",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retra\xE7\xE3o de Fibonacci",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Tend\xEAncia Baseada em Fib",
  toolbarAnnotationsFillColor: "Cor de Preenchimento",
  toolbarAnnotationsHorizontalLine: "Linha Horizontal",
  toolbarAnnotationsLineAnnotations: "Linhas de Tend\xEAncia",
  toolbarAnnotationsLineColor: "Cor da Linha",
  toolbarAnnotationsLineStrokeWidth: "Espessura do Tra\xE7o da Linha",
  toolbarAnnotationsLineStyle: "Estilo de Linha",
  toolbarAnnotationsLock: "Bloquear",
  toolbarAnnotationsMeasurerAnnotations: "Medidores",
  toolbarAnnotationsNote: "Nota",
  toolbarAnnotationsParallelChannel: "Canal Paralelo",
  toolbarAnnotationsPriceRange: "Faixa de Pre\xE7o",
  toolbarAnnotationsQuickDatePriceRange: "Medir",
  toolbarAnnotationsSettings: "Configura\xE7\xF5es",
  toolbarAnnotationsShapeAnnotations: "Setas",
  toolbarAnnotationsText: "Texto",
  toolbarAnnotationsTextAnnotations: "Anota\xE7\xF5es de Texto",
  toolbarAnnotationsTextColor: "Cor do Texto",
  toolbarAnnotationsTextSize: "Tamanho do Texto",
  toolbarAnnotationsTrendLine: "Linha de Tend\xEAncia",
  toolbarAnnotationsUnlock: "Desbloquear",
  toolbarAnnotationsVerticalLine: "Linha Vertical",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xEAs",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 ano",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 meses",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 meses",
  toolbarRangeAll: "Todos",
  toolbarRangeAllAria: "Tudo",
  toolbarRangeYearToDate: "YTD",
  toolbarRangeYearToDateAria: "Ano at\xE9 a data",
  toolbarSeriesTypeCandles: "Velas",
  toolbarSeriesTypeDropdown: "Tipo de Gr\xE1fico",
  toolbarSeriesTypeHighLow: "Alta Baixa",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Velas Vazadas",
  toolbarSeriesTypeLine: "Linha",
  toolbarSeriesTypeLineWithMarkers: "Linha com Marcadores",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linha de Passos",
  toolbarZoomPanEnd: "Panorar para o final",
  toolbarZoomPanLeft: "Mover para a esquerda",
  toolbarZoomPanRight: "Mover para a direita",
  toolbarZoomPanStart: "Mover para o in\xEDcio",
  toolbarZoomReset: "Redefinir o zoom",
  toolbarZoomZoomIn: "Aproximar",
  toolbarZoomZoomOut: "Diminuir zoom",
  tooltipPaginationStatus: "${index}[number] de ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_PT_BR
};
//# sourceMappingURL=pt-BR.esm.mjs.map
